import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { hasRestrictedAccessFor } from 'utils/helpers'

import { DashedBorderedButton } from 'components/Shared/Button'
import { useHistory } from 'react-router-dom'

const AddEvent = ({ user }) => {
    const { t } = useTranslation()
    const history = useHistory()
  
    return <div className='d-flex flex-row gap-2 mt-4 w-100'>
        <DashedBorderedButton
            disabled={hasRestrictedAccessFor(user.accessLevel, 'actions', 'canCreateEvent')}
            text={t('Simulation.addOneEvent')}
            color='navy'
            onClick={() => history.replace('/simulation')}
            showIcon={false}
            className="w-100"
        />
        <DashedBorderedButton
            disabled={hasRestrictedAccessFor(user.accessLevel, 'actions', 'canCreateEvent')}
            text={t('AddMultipleEvents.addEventsBtn')}
            color='navy'
            onClick={() => history.replace('/add-multi-events')}
            showIcon={false}
            className="w-100"
        />
    </div>
}

AddEvent.propTypes = {
    user: PropTypes.object.isRequired
}

export default AddEvent